<template>
  <div class="fromStyle">
    <a-form-model
      class="ruleForm"
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="项目" ref="project_id" prop="project_id">
        <a-select
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
          v-model="form.project_id"
          placeholder="请选择项目"
          @change="projectVal"
        >
          <a-select-option
            v-for="(item, i) in proList"
            :key="i"
            :value="item.id"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item ref="name" label="门店/大仓/区域名称" prop="name">
        <a-input v-model="form.name" />
      </a-form-model-item>
      <a-form-model-item label="所在区域">
        <area-select
          :level="2"
          type="text"
          :data="pcaa"
          v-model="form.cityVal"
        ></area-select>
      </a-form-model-item>
      <a-form-model-item ref="address" label="详细地址" prop="address">
        <a-input v-model="form.address" />
      </a-form-model-item>
      <a-form-model-item label="用户" v-show="form.project_id != ''">
        <a-select
          mode="multiple"
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
          v-model="form.user_ids"
        >
          <a-select-option
            :value="element.id"
            v-for="(element, i) in userList"
            :key="i"
            >{{ element.user_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 12, offset: 5 }">
        <a-button @click="resetForm">重置</a-button>
        <a-button style="margin-left: 10px" type="primary" @click="onSubmit"
          >提交</a-button
        >
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
import { pcaa } from "area-data";
import axios from "axios";
export default {
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 12 },
      form: {
        name: "",
        project_id: "",
        address: "",
        user_ids: [],
        cityVal: ["上海市", "市辖区", "黄浦区"]
      },
      rules: {
        name: [
          {
            required: true,
            message: "请填写门店/大仓/区域",
            trigger: "blur"
          }
        ],
        project_id: [
          {
            required: true,
            message: "请选择项目",
            trigger: "change"
          }
        ],
        address: [
          {
            required: true,
            message: "请输入详细地址",
            trigger: "blur"
          }
        ],
        cityVal: [
          {
            required: true,
            message: "请选择所在地区",
            trigger: "blur"
          }
        ]
      },
      proList: [],
      pcaa: pcaa,
      userList: [],
      province: "",
      city: "",
      area: "",
      details: {}
    };
  },
  mounted() {
    this.getPro(); //获取项目
    if (this.editDetail != undefined) {
      this.getDetails();
    }
  },
  props: {
    editDetail: {}
  },
  watch: {
    editDetail() {
      this.getDetails();
    }
  },
  methods: {
    getDetails() {
      this.details = this.editDetail;
      // console.log(this.details.guard_ids.split(",").map(Number));
      this.form = {
        name: this.details.name,
        project_id: this.details.project_id,
        address: this.details.address,
        user_ids:
          this.details.guard_ids == undefined
            ? []
            : this.details.guard_ids.split(",").map(Number),
        cityVal:
          this.details.province == ""
            ? (this.cityVal = ["上海市", "市辖区", "黄浦区"])
            : (this.cityVal = [
                this.details.province,
                this.details.city,
                this.details.area
              ]) //省市区
      };
      this.getUser(this.form.project_id);
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 4
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
            //  console.log(this.proList);
          }
        });
    },
    projectVal() {
      this.form.user_ids = [];
      this.getUser(this.form.project_id);
    },
    getUser(proID) {
      let url =
        this.httpsBasic.url + this.httpsBasic.retail + "Guard/guardList";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        per_page: 10000,
        project_id: proID,
        is_leave: 0
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.userList = res.data.data.data;
          // console.log(this.userList);
        }
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.area = this.form.cityVal[2];
          if (
            this.form.cityVal[0] == "上海市" ||
            this.form.cityVal[0] == "天津市" ||
            this.form.cityVal[0] == "北京市" ||
            this.form.cityVal[0] == "重庆市"
          ) {
            this.province = this.form.cityVal[0];
            this.city = this.form.cityVal[0];
          } else {
            this.province = this.form.cityVal[0];
            this.city = this.form.cityVal[1];
          }
          let url =
            this.httpsBasic.url + this.httpsBasic.retail + "Retail_shop/edit";
          let params = {
            id: this.details.id,
            project_id: this.form.project_id,
            name: this.form.name,
            province: this.province,
            city: this.city,
            area: this.area,
            address: this.form.address,
            user_ids: JSON.stringify(this.form.user_ids),
            token: window.localStorage.getItem("xnwfPcToken")
          };
          // console.log(params);
          axios
            .post(url, params)
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success("提交成功");
                this.resetForm();
                this.$emit("hideInEdit", false);
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("服务器出错了...");
            });
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    }
  }
};
</script>
<style lang="less" scoped>
.ruleForm {
  margin-top: 50px;
}
</style>
<style lang="less">
.fromStyle {
  .area-select .area-selected-trigger {
    padding: 0 20px 0 12px;
    line-height: 32px;
  }
}
</style>
